import { Bike, Loader2, PauseCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtTime } from "@/lib/api";
import { cn } from "@/lib/utils";

const STEP = {
  offering: ["Chamando entregadores no WhatsApp", "bg-blue-500/10 text-blue-700 dark:text-blue-300"],
  accepted: ["Aceito · indo para a loja", "bg-violet-500/10 text-violet-700 dark:text-violet-300"],
  arrived: ["Chegou na loja · confira o código", "bg-amber-500/15 text-amber-700 dark:text-amber-300"],
  dispatched: ["Retirou o pedido", "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300"],
  no_courier: ["Sem entregador", "bg-red-500/10 text-red-600 dark:text-red-400"],
  manual: ["Entregador escolhido pela loja", "bg-muted text-muted-foreground"],
};

export function PickupCode({ code }) {
  return (
    <div className="flex items-center justify-between rounded-md border border-dashed px-3 py-2" data-testid="order-pickup-code">
      <span className="text-xs text-muted-foreground">Código de coleta do entregador</span>
      <span className="font-mono text-xl font-bold tracking-[0.3em]">{code}</span>
    </div>
  );
}

export function DispatchBox({ o, info, busy, onCall, onPause }) {
  const d = o.dispatch;
  const canCall = ["confirmado", "preparo", "pronto"].includes(o.status);
  if (!d && !canCall) return null;
  const [label, tone] = d ? STEP[d.status] || STEP.manual : ["Os entregadores são chamados quando o pedido fica Pronto para entrega", "bg-muted text-muted-foreground"];
  return (
    <div className={cn("space-y-2 rounded-md p-3 text-sm", tone)} data-testid="order-dispatch-box">
      <p className="flex items-center gap-2 font-semibold" data-testid="order-dispatch-step"><Bike className="h-4 w-4 shrink-0" />{label}</p>
      {d?.status === "offering" && <p className="text-xs">Mensagem enviada às {fmtTime(d.sent_at)} · tentativa {d.round} de 2 · {d.offered.length - d.declined.length} entregador(es) podem aceitar</p>}
      {d?.courier && d.status !== "offering" && d.status !== "no_courier" && <p className="text-xs" data-testid="order-dispatch-courier">{d.courier.name} aceitou às {fmtTime(d.accepted_at)}{d.arrived_at ? ` · chegou às ${fmtTime(d.arrived_at)}` : ""}</p>}
      {d?.status === "no_courier" && <p className="text-xs">{d.reason}. Escolha um entregador abaixo ou chame de novo.</p>}
      {!info.whatsapp && <p className="text-xs">Conecte o WhatsApp da loja para chamar os entregadores automaticamente.</p>}
      {canCall && info.whatsapp && (!d || ["offering", "no_courier", "manual"].includes(d.status)) && (
        <div className="flex flex-wrap gap-2">
          <Button size="sm" variant="outline" disabled={busy} onClick={() => onCall(o)} data-testid={`order-dispatch-call-${o.number}`}>
            {busy ? <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> : <RefreshCw className="mr-1 h-3.5 w-3.5" />}{d ? "Chamar de novo" : "Chamar entregadores agora"}
          </Button>
          {d?.status === "no_courier" && info.menu_enabled && <Button size="sm" variant="outline" onClick={() => onPause(false)} data-testid={`order-dispatch-pause-${o.number}`}><PauseCircle className="mr-1 h-3.5 w-3.5" />Bloquear vendas do cardápio</Button>}
        </div>
      )}
    </div>
  );
}
